import { Actions } from '@williamhill/rosi-ui-shared/src/store/action-types';

export const openKeyboard = ({ field }) => ({ type: Actions.openKeyboard, field });
export const closeKeyboard = () => ({ type: Actions.closeKeyboard });
export const setKeyboardValue = ({ value, field }) => ({ type: Actions.setKeyboardValue, value, field });
export const clearKeyboardValue = () => ({ type: Actions.clearKeyboardValue });
